import React from 'react'
import styled from 'styled-components'
import leaf from '../../../images/careers-leaf.jpg'
import { Parallax, ParallaxProvider } from 'react-scroll-parallax'

const DiamondsWrapper = styled.div`
  position: relative;
  text-align: center;
  padding: 220px 0 0;
  overflow: hidden;
  margin: 50px -30px -100px;
  z-index: 2;

  @media (min-width: 960px) {
    position: absolute;
    right: -10%;
    top: -100px;
    bottom: -100px;
    width: 60%;
    margin: 0;
    padding: 0;

    &:before {
      content: '';
      position: absolute;
      z-index: 2;
      top: 0;
      bottom: 0;
      width: 20px;
      left: 0;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );
    }
  }
`

const bgMap = {
  grey: 'careers_midblue12',
  cta: 'careers_midblue'
}

const DiamondLink = styled.a`
  width: 210px;
  height: 210px;
  color: ${(props) => props.theme.colors.white};
  text-decoration: none;
  position: relative;
  display: block;
  margin: 0 auto 200px;
  z-index: 2;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform: rotate(45deg);
    transform-origin: center center;
    background-color: ${(props) => props.theme.colors.careers_midblue};
    border-radius: 20%;
  }

  &:hover,
  &:focus {
    h2 {
      color: ${(props) => props.theme.colors.white} !important;
      text-decoration: underline !important;
    }

    p {
      color: ${(props) => props.theme.colors.white} !important;
    }
  }

  @media (min-width: 960px) {
    position: absolute;
    top: ${(props) => props.position[0]}px;
    right: ${(props) => props.position[1]}%;
    width: 180px;
    height: 180px;
    margin: 0;
  }

  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 85%;
  }

  h2,
  p {
    width: 100% !important;
    margin-bottom: 0;
  }

  h2 {
    font-size: 18px;
    line-height: 1;
    margin-bottom: 10px;
    color: ${(props) => props.theme.colors.white} !important;

    @media (min-width: 960px) {
      font-size: 27px;
    }
  }

  p {
    font-size: 16px;
    line-height: 24px;
    @media (max-width: 959px) {
      display: block !important;
      margin-bottom: 0 !important;
    }
  }
`

const DiamondInner = styled.div`
  width: ${(props) => props.size[0]}px;
  height: ${(props) => props.size[0]}px;
  border: ${(props) => props.variant === 'outline' && '2px solid'};
  border-radius: 10%;
  transform: rotate(45deg);
  position: absolute;
  top: ${(props) => props.position[0][0]}px;
  right: ${(props) => props.position[0][1]}%;
  background-color: ${(props) => props.theme.colors[bgMap[props.variant]]};
  background-image: ${(props) => `url(${props.image})`};
  background-size: cover;
  background-position: center center;

  @media (min-width: 960px) {
    width: ${(props) => props.size[1]}px;
    height: ${(props) => props.size[1]}px;
    top: ${(props) => props.position[1][0]}px;
    right: ${(props) => props.position[1][1]}%;
  }
`

const Diamond = (props) => (
  <Parallax speed={props.speed}>
    <DiamondInner {...props} />
  </Parallax>
)

const Diamonds = () => (
  <ParallaxProvider>
    <DiamondsWrapper>
      <Diamond
        position={[
          [400, 75],
          [-50, 20]
        ]}
        variant="grey"
        size={[140, 140]}
        speed={-15}
      />
      <Diamond
        position={[
          [470, 5],
          [315, 68]
        ]}
        variant="grey"
        size={[140, 208]}
        speed={-15}
      />
      <Diamond
        position={[
          [100, 100],
          [620, 65]
        ]}
        variant="grey"
        size={[0, 140]}
        speed={-15}
      />
      <Diamond
        position={[
          [75, 25],
          [100, 43]
        ]}
        variant="outline"
        size={[250, 240]}
        speed={-20}
      />
      <Diamond
        position={[
          [540, -30],
          [310, 12]
        ]}
        variant="outline"
        size={[340, 470]}
        speed={-25}
      />
      <Diamond
        position={[
          [50, 0],
          [50, 25]
        ]}
        image={`https://media.auto.works/original/cbb6b422eb1a6e584e1c3f39928e27cb:c1a42e2e3efa6ddad7e7fd9659e559d6`}
        size={[140, 140]}
        speed={-10}
      />
      <Diamond
        position={[
          [570, 3],
          [260, 40]
        ]}
        image={leaf}
        size={[100, 120]}
        speed={-10}
      />
      <Diamond
        position={[
          [430, 58],
          [330, 67]
        ]}
        image={`https://media.auto.works/original/0b5c0e7790ee75c8867569dc3a590d64:dbce1b2bb017589bf97d4a7ad92f5d81`}
        size={[140, 180]}
        speed={-10}
      />
      <DiamondLink
        href="http://citygate.co.uk/citygate-values"
        position={[180, 50]}
      >
        <div>
          <h2>Our Values</h2>
          <p>What makes us unique</p>
        </div>
      </DiamondLink>
      <DiamondLink
        href="http://citygate.co.uk/citygate-values"
        position={[520, 42]}
      >
        <div>
          <h2>Our benefits</h2>
          <p>Something good for everyone</p>
        </div>
      </DiamondLink>
    </DiamondsWrapper>
  </ParallaxProvider>
)

export default Diamonds
